import { getContext } from './images.js'
import { ShadowText } from './main.js'
import { ShadowText as ShadowTextMenu } from './scene-menu.js'

let ctx = null
let deathStats = {}

function Reset() {
    frame = maxFrame
}

function DeathStats(stats) {
    deathStats = stats
}

function AnimationFrame(delta) {
    if (!ctx) {
        ctx = getContext()
    }
    ctx.clearRect(0, 0, 64, 64)

    let title = 'YOU LOST'
    if (deathStats.lossReason === 'death') {
        title = 'YOU DIED'
    }
    ShadowText(32 - parseInt((title.length * 5) / 2), 3, title, '#f10000ff', '#ca0000a9')

    bfontjs.DrawText(ctx, 5, 15, `LEVEL ${deathStats.levelNumber}`, '#f1f1f1ff', font)
    bfontjs.DrawText(ctx, 5, 22, `TIME LEFT ${parseInt(deathStats.levelTimer / 1000)}`, '#f1f1f1ff', font)
    
    let reason = ''
    if (deathStats.lossReason === 'cabin') {
        reason = 'THE CABIN\nEXPLODED'
        bfontjs.DrawText(ctx, 5, 32, reason.split('\n')[0], '#f1f1f1ff', font)
        bfontjs.DrawText(ctx, 5, 38, reason.split('\n')[1], '#f1f1f1ff', font)
    }
    

    ShadowTextMenu(5, 56, 'MAIN MENU', '#fffc40ff', '#303030d9', undefined, eighties)
}

export { AnimationFrame, Reset, DeathStats }